module.exports = __webpack_public_path__ + "img/28.8.c4767f0b.png";